
















import Vue, { VueConstructor } from 'vue';
import { AxiosResponse, AxiosError } from 'axios';
import services from '../../../../services';
import { CaseInformation, AttendanceInformation } from '../../../../models/api-client';
import { CaseVm } from '../viewModel';
import mapper from '../mappers';
import { PageTitle } from '@/common/components';
import OpenCasesTable from '@/views/Customer/Cases/Open/components/OpenCasesTable.vue';
import { ToastMessage } from '@/plugins/toast/models/message';
import { ErrorStatesOptions } from '@/models/errorEntities';
import lang from '../../../../common/lang/de';

const { UserService } = services;

export default (Vue as VueConstructor<Vue & {
  $refs: {},
}>).extend({
  name: 'OpenCases',
  components: {
    PageTitle,
    OpenCasesTable,
  },
  data() {
    return {
      userId: '' as string,
      expand: false as boolean,
      isMobile: false as boolean,
      title: 'Open Cases' as string,
      headers: [
        { text: 'Beschreibung', value: 'caseDescriptionShort' },
        { text: 'Eröffnet am', value: 'createDate' },
        { text: 'Produkt', value: 'caseGroup1' },
        { text: 'Status', value: 'caStDescription' },
        { text: 'Zuständig', value: 'staffSignature' },

      ],
      subHeaders: [
        { text: 'Mitarbeitername', value: 'staffSignature' },
        { text: 'Beschreibung', value: 'caTcDescription' },
        { text: 'Datum (Startzeit)', value: 'caTcStart' },
        { text: 'Uhrzeit (Startzeit)', value: 'hour' },
      ],
      data: [] as CaseVm[],
    };
  },
  created() {
    this.userId = this.$route.params.id;
  },
  methods: {
    goTo() {
      this.$router.push({
        name: 'Welcome',
        params: {
          id: this.userId,
        },
      });
    },
    onResize() {
      if (window.innerWidth < 769) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    getAllOpenCases() {
      this.$loader.show();
      UserService.getAllOpenCases(this.$store.getters['user/getDebtorNumber']).then((result: AxiosResponse<CaseInformation[]>) => {
        this.data = mapper.mapCaseListDtoToCaseListOpenVm(result.data);
        setTimeout(() => {
          this.$loader.hide();
        }, 500);
      }).catch((err: AxiosError) => {
        if ((err.response !== undefined) && (err.response.status === 401 || err.response.status === 500)) {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.NotAuthorized);
          this.$router.push({ name: 'Index' });
        } else {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.UnexpectedError);
        }
      });
    },
    expandAttendanceOpenCase(props: any) {
      if (props.expanded) {
        UserService.getAttendanceCase(props.item.caseId).then((result: AxiosResponse<AttendanceInformation[]>) => {
          const index = this.data.findIndex(d => d.caseId === props.item.caseId);
          this.data[index].attendance = mapper.mapAttendanceListDtoToAttendanceListVm(result.data);
        }).catch((err: AxiosError) => {
          if ((err.response !== undefined) && (err.response.status === 401 || err.response.status === 500)) {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.NotAuthorized);
            this.$router.push({ name: 'Index' });
          } else {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.UnexpectedError);
          }
        });
      }
    },
    showError(error: ErrorStatesOptions) {
      const toast = {} as ToastMessage;
      switch (error) {
        case ErrorStatesOptions.NotAuthorized:
          toast.header = lang.global.error.NotAuthorized.header;
          toast.message = lang.global.error.NotAuthorized.message;
          break;
        case ErrorStatesOptions.UnexpectedError:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
        default:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
      }
      this.$toast.error(toast);
    },
  },
});
